import { useState } from "react";
import { useTablesContext } from "../../../../context/tablesContextProvider";
import { TableNames } from "../../../../enums/tableNames";

/**
 * Manages the free-text search term for the All Open Orders table, seeded from
 * the persisted table context.
 *
 * @returns The current searchTerm and its setter
 */
export const useSearchTerm = () => {
  const { getTableDataFromContext } = useTablesContext();
  const tableAttributes = getTableDataFromContext(TableNames.ALL_OPEN_ORDERS);

  const [searchTerm, setSearchTerm] = useState(
    tableAttributes?.searchedText ?? "",
  );

  return {
    searchTerm,
    setSearchTerm,
  };
};
